// import { Plus } from 'lucide-react'
// import React from 'react'
// import './VoucherEntry.css'

// const VoucherEntry = () => {
//   return (
//     <>
//         <div className="payment-container">
//         <h1 className="payment-heading">Payment Voucher</h1>

//         {/* ================= FORM ================= */}
//         <section className="payment-top">
//           <form className="payment-form" >
//             <div className="payment-form-section">
//               <div className="payment-form-input-fields">
//                 <label>Branch</label>
//                 <select name="paymentType" >
//                   <option value=""></option>
//                 </select>
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>Date</label>
//                 <input type="date" name="date"  />
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>Voucher Type</label>
//                 <select name="fromBranch"  >
//                   <option value=""></option>
//                 </select>
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>CR. Account</label>
//                 <select name="toBranch"  >
//                   <option value=""></option>
//                 </select>
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>DR. Account</label>
//                 <select name="fromLedger" >
//                   <option value=""></option>
//                 </select>
//               </div>

//               <div className="payment-form-input-fields">
//                 <label>Amount</label>
//                 <input type="text" />
//               </div>
//             </div>

//             <div className="payment-narration-input">
//               <label>Narration</label>
//               <textarea name="narration" ></textarea>
//             </div>

//             <div className="payment-form-submit-btn">
//               <button type="submit">Save</button>
//             </div>
//           </form>
//         </section>

//         {/* ================= REPORT SECTION ================= */}
//         <div className="payment-report-container">
//           <div className="payment-report-table-container">
//             <h1>Payment Voucher Report</h1>
//             <div className="payment-report-table">
//             <table>
//               <thead>
//                 <tr>
//                   <th>SN.</th>
//                   <th>Particular</th>
//                   <th className="amount-head">
//                     <div className="payment-th-data">
//                       <h4>Amount</h4>
//                       <div className="payment-th-amount">
//                         <span>DR</span>
//                         <span>CR</span>
//                       </div>
//                     </div>
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {/* Row Sample */}
//                 <tr>
//                   <td>1</td>
//                   <td></td>
//                   <td className="amount-row">
//                     <span>200</span>
//                     <span>0</span>
//                   </td>
//                 </tr>

//                 {/* Footer Total Row */}
//                 <tr className="totalRow">
//                   <td colSpan="2">TOTAL</td>
//                   <td>
//                     <div className="payment-th-amount">
//                       <p>200</p>
//                       <p>0</p>
//                     </div>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//           </div>
//           </div>
//         </div>
//     </>
//   )
// }

// export default VoucherEntry



import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VoucherEntry.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const VoucherEntry = () => {
  const [ledger, setLedger] = useState([]);
  const [selectedLedger, setSelectedLedger] = useState(null);
  const [debitAccountLedger, setDebitAccountLedger] = useState([]);
  const [selectedDebitAccountLedger, setSelectedDebitAccountLedger] = useState(null);

  const [formData, setFormData] = useState({
    voucherType: "",
    date: "",
    narration: "",
    amount: "",
    ledgerType: "",
  });

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  console.log(profile)


  // ✅ Fetch Profile
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  /* =================FETCH BRANCH LEDGER LIST=================*/
  useEffect(() => {
    const fetchLedgers = async () => {
      if(!profile?.superAdminId) return;
      try {
        const res = await axios.get(`${API_URL}/ledger/getall`, {
          params: {
            superAdminId: profile?.superAdminId,
            branch_id: profile?.branchId,
            limit: 100000,
          },
        });

        const debitLedger = res?.data?.rows?.filter(
          (dl) => dl.name.toLowerCase() === "cash"
        );
        const ledger = res?.data?.rows?.filter(
          (l) => l.name.toLowerCase() !== "cash" && l.name.toLowerCase() !== "bank"
        );
        setLedger(ledger || []);
        setDebitAccountLedger(debitLedger || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchLedgers();
  }, [profile]);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  console.log("selected branch ledger", selectedLedger?.id);
  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedLedger) {
      toast.warn("Please select Ledger");
      return;
    }

    if (!selectedDebitAccountLedger) {
      toast.warn("Please select Debit Account");
      return;
    }

    if (!formData.amount) {
      toast.warn("Amount is required");
      return;
    }
    if (!formData.voucherType) {
      toast.warn("Please select voucher type.")
      return;
    }

    const payload = {
      voucherType: formData?.voucherType,
      voucherNo: `PAY${Date.now()}`,
      date: formData.date,
      narration: formData.narration,
      branchId: profile?.branchId,
      superAdminId: profile?.superAdminId,
      createdBy: profile?.id || localStorage.getItem("userId"),
      entry: {
        ledgerId: Number(selectedLedger?.id),
        amount: Number(formData.amount),
        ledgerType: selectedLedger?.name,
      },
      [formData?.voucherType === "payment"
        ? "paymentAccountLedgerId"
        : "receiptAccountLedgerId"]: selectedDebitAccountLedger?.id,
    };

    try {
      if (formData?.voucherType === "payment") {
        const res = await axios.post(`${API_URL}/ledger-entry/create-voucher-new`, payload);
        toast.success(res?.data?.message || "Payment Voucher Created Successfully");
      } else {
        const res = await axios.post(`${API_URL}/ledger-entry/create-reciept-voucher-new`, payload);
        toast.success(res?.data?.message || "Payment Voucher Created Successfully");
      }


      // reset
      setFormData({
        voucherType: "",
        date: "",
        narration: "",
        amount: "",
        ledgerType: "",
      });
      setSelectedLedger(null);
    } catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.message || "Failed to create payment voucher"
      );
    }
  };

  return (
    <div className="payment-container">
      <h1 className="payment-heading">{formData?.voucherType.toUpperCase()} Voucher Entry</h1>

      <div className="payment-top">
        <form className="payment-form" onSubmit={handleSubmit}>
          <div className="payment-form-section">

            {/* DR Account */}
            <div className="payment-form-input-fields">
              <label>Voucher Type</label>
              <select
                value={formData.voucherType}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    voucherType: e.target.value,
                  }))
                }
              >
                <option value="">Select Voucher Type</option>
                <option value="payment">Payment (Deduct)</option>
                <option value="receipt">Receipt (Credit)</option>
              </select>
            </div>

            {/* DR Account */}
            <div className="payment-form-input-fields">
              <label>Payment Type</label>
              <select
                value={selectedDebitAccountLedger?.id || ""}
                onChange={(e) => {
                  const debitAccount = debitAccountLedger.find(
                    (bl) => bl.id === Number(e.target.value)
                  );
                  setSelectedDebitAccountLedger(debitAccount);
                }}
              >
                <option value="">Select Payment Type</option>
                {debitAccountLedger.map((bl) => (
                  <option key={bl.id} value={bl.id}>
                    {bl?.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="payment-form-input-fields">
              <label>Ledger</label>
              <select
                value={selectedLedger?.id || ""}
                onChange={(e) => {
                  const ledgerData = ledger.find(
                    (bl) => bl.id === Number(e.target.value)
                  );
                  setSelectedLedger(ledgerData);
                }}
              >
                <option value="">Select Ledger</option>
                {ledger.map((bl) => (
                  <option key={bl.id} value={bl.id}>
                    {bl?.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Amount */}
            <div className="payment-form-input-fields">
              <label>Amount</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
              />
            </div>
            {/* Date */}
            <div className="payment-form-input-fields">
              <label>Date</label>
              <input
                required
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Narration */}
          <div className="payment-narration-input">
            <label>Narration</label>
            <textarea
              required
              name="narration"
              value={formData.narration}
              onChange={handleChange}
            />
          </div>

          <div className="payment-form-submit-btn">
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VoucherEntry;
